export default __webpack_public_path__ + "static/media/date_error.723b3d82.svg";